import { render, staticRenderFns } from "./InitFromMarketPlace.vue?vue&type=template&id=5fe24cc1&scoped=true"
import script from "./InitFromMarketPlace.vue?vue&type=script&lang=ts"
export * from "./InitFromMarketPlace.vue?vue&type=script&lang=ts"
import style0 from "./InitFromMarketPlace.vue?vue&type=style&index=0&id=5fe24cc1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5fe24cc1",
  null
  
)

export default component.exports